import { Row, Col, Input, Tabs } from "antd";
import CancelArrow from "../../../assets/images/cancelArrow.svg";

const { TabPane } = Tabs;

const QtyPricePanel = ({
  showInputFields,
  selectedProductInCart,
  qtyInputRef,
  realPriceRef,
  realPrice,
  setRealPrice,
  cart,
  onChangeTotalQuantity,
  setIsInputFocused,
  enterTotalQty,
  handleTotalQty,
  decreaseProductQty,
  increaseProductQty,
  handleRealPrice,
  enterRealPrice,
}) => {
  if (!showInputFields) {
    return (
      <div>
        <Row style={{ margin: "2% 0 0 0" }}>
          <Input
            className="productSearch sm-payment-search totalQtyInput"
            style={{
              borderRadius: "0.5vw",
              height: "8.3vh",
              margin: "0 1% 2.7% 3.5%",
              textAlign: "right",
              fontWeight: "500",
              fontSize: "2.5em",
              borderColor: "#fff",
              color: "#2F3856",
              fontFamily: "Inter",
            }}
            ref={qtyInputRef}
            value={selectedProductInCart.weight}
            id="sm-amount-input"
            autoComplete="off"
            onChange={(e) => {
              if (cart.items.length > 0 && Object.keys(selectedProductInCart).length > 0) {
                onChangeTotalQuantity(e.target.value?.replace(/[^\d.]/g, ""));
              }
            }}
            readOnly={cart.items.length > 0 && Object.keys(selectedProductInCart).length > 0 ? false : true}
            placeholder="Enter Quantity"
            onFocus={() => setIsInputFocused(true)}
            onBlur={() => setIsInputFocused(false)}
            onPressEnter={enterTotalQty}
          />
        </Row>
        <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
          <Col span={6}>
            <button id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleTotalQty("1")}>
              1
            </button>
          </Col>
          <Col span={6}>
            <button id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleTotalQty("2")}>
              2
            </button>
          </Col>
          <Col span={6}>
            <button id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleTotalQty("3")}>
              3
            </button>
          </Col>
          <Col span={6}>
            <button
              className="amt-dial-btn-market"
              id="sm-amount-buttonRemove"
              onClick={() => handleTotalQty("x")}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={CancelArrow}
                alt="back space"
                style={{
                  width: "1.4vw",
                  height: "1.4vw",
                  objectFit: "contain",
                }}
              />
            </button>
          </Col>
          <Col span={6}>
            <button id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleTotalQty("4")}>
              4
            </button>
          </Col>
          <Col span={6}>
            <button id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleTotalQty("5")}>
              5
            </button>
          </Col>
          <Col span={6}>
            <button id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleTotalQty("6")}>
              6
            </button>
          </Col>
          <Col span={6}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <button
                id="sm-amount-addQuantity"
                onClick={() => {
                  if (Object.keys(selectedProductInCart).length > 0) decreaseProductQty(selectedProductInCart);
                }}
                className="amt-dial-btn-market-qty"
              >
                -
              </button>
              <button
                id="sm-amount-addQuantity"
                onClick={async () => {
                  if (Object.keys(selectedProductInCart).length > 0) increaseProductQty(selectedProductInCart);
                }}
                className="amt-dial-btn-market-qty"
              >
                +
              </button>
            </div>
          </Col>
          <Col span={18}>
            <Row gutter={[8, 6]}>
              <Col span={8}>
                <button id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleTotalQty("7")}>
                  7
                </button>
              </Col>
              <Col span={8}>
                <button id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleTotalQty("8")}>
                  8
                </button>
              </Col>
              <Col span={8}>
                <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("9")}>
                  9
                </button>
              </Col>
              <Col span={8}>
                <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("0")}>
                  0
                </button>
              </Col>
              <Col span={8}>
                <button id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleTotalQty(".")}>
                  .
                </button>
              </Col>
              <Col span={8}>
                <button id="sm-amount-button." className="amt-dial-btn-market" onClick={() => handleTotalQty("clear")}>
                  Clear
                </button>
              </Col>
            </Row>
          </Col>
          <Col span={6}>
            <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterTotalQty}>
              Enter
            </button>
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div>
      <Tabs
        defaultActiveKey="1"
        className="custom-tabs"
        onChange={(key) => {
          if (key === "2") {
            setTimeout(() => {
              realPriceRef?.current?.focus();
            }, 10);
          } else if (key === "1") {
            setTimeout(() => {
              qtyInputRef?.current?.focus();
            }, 10);
          }
        }}
        style={{
          marginTop: "-11%",
          marginLeft: "4%",
          width: "94%",
          height: "auto",
          zIndex: 1000,
          transition: "top 0.5s ease",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
        }}
      >
        <TabPane tab="Qty" key="1" className="custom-tabpane" style={{ marginRight: "1vw" }}>
          <Row style={{ margin: "0 0 0 0" }}>
            <Input
              className="productSearch sm-payment-search totalQtyInput"
              value={selectedProductInCart.weight}
              ref={qtyInputRef}
              style={{
                borderRadius: "0.5vw",
                height: "6.5vh",
                margin: "0% 1% 1% 0%",
                textAlign: "right",
                fontWeight: "500",
                fontSize: "2.5em",
                color: "#2F3856",
                borderColor: "#fff",
              }}
              id="sm-amount-input"
              placeholder="Enter Quantity"
            />
          </Row>
          <Row style={{ padding: "0 1% 0 0", marginTop: "1vh" }} gutter={[8, 6]}>
            <Col span={6}>
              <button id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleTotalQty("1")}>
                1
              </button>
            </Col>
            <Col span={6}>
              <button id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleTotalQty("2")}>
                2
              </button>
            </Col>
            <Col span={6}>
              <button id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleTotalQty("3")}>
                3
              </button>
            </Col>
            <Col span={6}>
              <button
                className="amt-dial-btn-market"
                id="sm-amount-buttonRemove"
                onClick={() => handleTotalQty("x")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={CancelArrow}
                  alt="back space"
                  style={{
                    width: "1.4vw",
                    height: "1.4vw",
                    objectFit: "contain",
                  }}
                />
              </button>
            </Col>
            <Col span={6}>
              <button id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleTotalQty("4")}>
                4
              </button>
            </Col>
            <Col span={6}>
              <button id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleTotalQty("5")}>
                5
              </button>
            </Col>
            <Col span={6}>
              <button id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleTotalQty("6")}>
                6
              </button>
            </Col>
            <Col span={6}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <button
                  id="sm-amount-addQuantity"
                  onClick={() => {
                    if (Object.keys(selectedProductInCart).length > 0) decreaseProductQty(selectedProductInCart);
                  }}
                  className="amt-dial-btn-market-qty"
                >
                  -
                </button>
                <button
                  id="sm-amount-addQuantity"
                  onClick={async () => {
                    if (Object.keys(selectedProductInCart).length > 0) increaseProductQty(selectedProductInCart);
                  }}
                  className="amt-dial-btn-market-qty"
                >
                  +
                </button>
              </div>
            </Col>
            <Col span={18}>
              <Row gutter={[8, 6]}>
                <Col span={8}>
                  <button id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleTotalQty("7")}>
                    7
                  </button>
                </Col>
                <Col span={8}>
                  <button id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleTotalQty("8")}>
                    8
                  </button>
                </Col>
                <Col span={8}>
                  <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("9")}>
                    9
                  </button>
                </Col>
                <Col span={8}>
                  <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("0")}>
                    0
                  </button>
                </Col>
                <Col span={8}>
                  <button id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleTotalQty(".")}>
                    .
                  </button>
                </Col>
                <Col span={8}>
                  <button id="sm-amount-button." className="amt-dial-btn-market" onClick={() => handleTotalQty("clear")}>
                    Clear
                  </button>
                </Col>
              </Row>
            </Col>
            <Col span={6}>
              <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterTotalQty}>
                Enter
              </button>
            </Col>
          </Row>
        </TabPane>
        <TabPane tab="Price" key="2" className="custom-tabpane" style={{ marginRight: "1vw" }}>
          <Row style={{ margin: "0 0 0 0" }}>
            <Input
              className="productSearch sm-payment-search totalQtyInput"
              ref={realPriceRef}
              value={realPrice}
              onChange={(e) => setRealPrice(e.target.value)}
              style={{
                borderRadius: "0.5vw",
                height: "6.5vh",
                margin: "0% 1% 1% 0%",
                textAlign: "right",
                fontWeight: "500",
                fontSize: "2.5em",
                color: "#2F3856",
                borderColor: "#fff",
              }}
              id="sm-amount-input"
              placeholder="Enter Price"
            />
          </Row>
          <Row style={{ padding: "0 1% 0 0", marginTop: "1vh" }} gutter={[8, 6]}>
            <Col span={6}>
              <button id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleRealPrice("1")}>
                1
              </button>
            </Col>
            <Col span={6}>
              <button id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleRealPrice("2")}>
                2
              </button>
            </Col>
            <Col span={6}>
              <button id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleRealPrice("3")}>
                3
              </button>
            </Col>
            <Col span={6}>
              <button className="amt-dial-btn-market" id="sm-amount-buttonRemove" onClick={() => handleRealPrice("x")}>
                <img
                  src={CancelArrow}
                  style={{
                    width: "1.4vw",
                    height: "1.4vw",
                    objectFit: "contain",
                  }}
                />
              </button>
            </Col>
            <Col span={6}>
              <button id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleRealPrice("4")}>
                4
              </button>
            </Col>
            <Col span={6}>
              <button id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleRealPrice("5")}>
                5
              </button>
            </Col>
            <Col span={6}>
              <button id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleRealPrice("6")}>
                6
              </button>
            </Col>
            <Col span={6}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <button
                  id="sm-amount-addQuantity"
                  className="amt-dial-btn-market-qty"
                  onClick={() => {
                    setRealPrice((prev) => {
                      const numeric = parseFloat(prev) || 0;
                      return Math.max(numeric - 1, 1).toString();
                    });
                  }}
                >
                  -
                </button>
                <button
                  id="sm-amount-addQuantity"
                  className="amt-dial-btn-market-qty"
                  onClick={() => {
                    setRealPrice((prev) => {
                      const numeric = parseFloat(prev) || 0;
                      return (numeric + 1).toString();
                    });
                  }}
                >
                  +
                </button>
              </div>
            </Col>
            <Col span={18}>
              <Row gutter={[8, 6]}>
                <Col span={8}>
                  <button id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleRealPrice("7")}>
                    7
                  </button>
                </Col>
                <Col span={8}>
                  <button id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleRealPrice("8")}>
                    8
                  </button>
                </Col>
                <Col span={8}>
                  <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleRealPrice("9")}>
                    9
                  </button>
                </Col>
                <Col span={8}>
                  <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleRealPrice("0")}>
                    0
                  </button>
                </Col>
                <Col span={8}>
                  <button id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleRealPrice("00")}>
                    00
                  </button>
                </Col>
                <Col span={8}>
                  <button id="sm-amount-button." className="amt-dial-btn-market" onClick={() => handleRealPrice(".")}>
                    .
                  </button>
                </Col>
              </Row>
            </Col>
            <Col span={6}>
              <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterRealPrice}>
                Enter
              </button>
            </Col>
          </Row>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default QtyPricePanel;
